import { styled } from '@mui/material/styles';

export const StyledPanelContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.info.light};
  padding: ${({ theme }) => theme.spacing(1.5, 4)};
`;
